module.exports = require('./src/angular-base64-upload.js');
